import * as types from "./types";
import { combineReducers } from "redux";
import sortBy from "lodash/sortBy";

function dataSaved(state = { status: false, message: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, message: "" }
      : state;
}

function incidencias(state = [], { type, payload }) {
  return type === types.FETCH
    ? sortBy([...state, payload], ["fecha"])
    : type === types.CHANGED
      ? sortBy(state.map(item => (item.id === payload.id ? payload : item)), [
          "fecha"
        ])
      : type === types.REMOVED
        ? sortBy(state.filter(item => item.id !== payload.id), ["fehca"])
        : type === types.RESET
          ? []
          : state;
}

const reducer = combineReducers({
  dataSaved,
  incidencias
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/incidencias/reducers.js